import * as React from 'react';
import Card from 'src/core/ui/card';
import Grid from 'src/core/ui/grid';
import { Col } from '../../../core/ui/grid';
import Divider from 'src/core/ui/divider';
import { ImageUpload } from 'src/core/ui/upload';

import TextArea from 'src/core/ui/textarea';
import {IDescriptionModule} from "../../../typings";

export interface ArtDescriptionProps {
    model: IDescriptionModule;
    onChange: (data: IDescriptionModule) => void;
}

export interface ArtDescriptionState {
}

export default class ArtDescription extends React.Component<ArtDescriptionProps, ArtDescriptionState> {
  constructor(props: ArtDescriptionProps) {
    super(props);

    this.state = {
    }
  }

  handleChange = (id: keyof IDescriptionModule, value: any) => {
    this.props.model[id] = value;
    this.props.onChange({...this.props.model});
  }


  public render() {

    const item = this.props.model;

    return (
        <Card
            header={<div className='card-header-switch'><h2 className='card-header-text'>Description module </h2> 
            </div>}
                            
    >
        <Grid centered>
            <Col size={50}>
                <div className='module-description'>
                    <h3>Art work description</h3>
                    <Divider/>
                    <TextArea 
                        onChange={e => this.handleChange('description', e)}
                        value={item.description} 
                    />
                </div>
            </Col>
            <Col size={50} className='fill'>
                
                <ImageUpload
                    value={item.image}
                    onDelete={() => this.handleChange('image', null)}
                    onUpload={e => {
                        this.handleChange('image', e.id)
                    }}
                    style={{height: '100%'}}/>
            </Col>
        </Grid>

    </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/arts/parts/art-description.tsx